import React from 'react'
import { Icon } from 'labguard-cdk'

export default function MeanIcon(props) {
  return (
    <Icon {...props}>
      <i style={{ fontFamily: 'serif', fontWeight: 'bold' }}>x̄</i>
    </Icon>
  )
}
